module.exports = __webpack_public_path__ + "static/media/stats.6cba6607.svg";